import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BlocRecherche } from '../../models/online-market/BlocRecherche';
import { QueovalDateService, UtilitiesService } from '../../services';
import { ToastService } from '../../toast';

@Component({
  selector: 'q-template-search',
  templateUrl: './template-search.component.html',
  styleUrls: ['./template-search.component.css']
})
export class TemplateSearchComponent implements OnInit {
  // #region Variable globale
  public TypeBlocSelected: string;

  public BlocSelected: BlocRecherche;

  public showPopover: boolean;




  // #endregion

  //@Input('TypeBlocSelected') set SetTypeBloc(value: string) {
  //  if (!this.utilities.isEmptyStr(value)) {
  //    this.TypeBlocSelected = value;
  //  }
  //}

  @Input('BlocSelected') set SetBloc(value: BlocRecherche) {
    this.BlocSelected = value;
  }

  @Input('showPopover') set SetShowPopover(value: boolean) {
    this.showPopover = value;
  }

  @Output() EventCondition: EventEmitter<string> = new EventEmitter<string>();


  // #region constructor
  constructor(
    public utilities: UtilitiesService,
    protected toasts: ToastService,
    public datepipe: DatePipe,
    public qDateService: QueovalDateService
  ) { }

  // #endregion

  ngOnInit(): void {
    if (this.BlocSelected.TypeBloc == 'INT' || this.BlocSelected.TypeBloc == 'MONEY') {
      if (!this.utilities.isEmptyStr(this.BlocSelected.Value)) {

        this.BlocSelected.ValueInt = parseInt(this.BlocSelected.Value.replace("'", ''));
      }
    }
  }

  // #region Fonctions public



  public OnValueChange(bloc: BlocRecherche, event: any) {


    bloc.Value = '';
    switch (bloc.TypeBloc) {
      case 'NVARCHAR':
        bloc.Operator = 'LIKE';
        bloc.Value = event.target.value;
        if (!this.utilities.isEmptyStr(event.target.value)) {

          bloc.Condition = `${bloc.Column} ${bloc.Operator} '%${bloc.Value.replace("'", ("''"))}%' COLLATE SQL_Latin1_General_Cp437_CI_AI`;
        } else {
          bloc.Condition = '';
        }
        break;
      case 'BOOLEAN':
        bloc.Value = event;
        bloc.Operator = '=';
        if (bloc.Value == 'YES') {
          bloc.Condition = `${bloc.Column} ${bloc.Operator} ''true''`;
        } else if (bloc.Value == 'NO') {
          bloc.Condition = `${bloc.Column} ${bloc.Operator} ''false''`;
        } else {
          bloc.Condition = '';
        }
        break;


      case 'MONEY':
      case 'INT':

        bloc.Value = event.target.value;
        if (!this.utilities.isEmptyStr(bloc.Value)) {
          bloc.ValueInt = parseInt(bloc.Value);
          bloc.Condition = `${bloc.Column} ${bloc.Operator} ''${bloc.Value}''`;
        } else {
          bloc.Condition = '';
        }
        break;
      default:
        bloc.Operator = '=';
        break;


    }
    this.EventCondition.emit(bloc.Condition);
  }


  public OnOperatorChange(bloc: BlocRecherche, newOperator: string) {
    if (bloc.Value) {
      bloc.Condition = `${bloc.Column} ${newOperator} ''${bloc.Value}''`;
    }
  }


  public OnFromDateChange(bloc: BlocRecherche, value: string) {
    //Recuperer la value du bloc, verifier la présence du pipe, si il y'a un pipe remplacer ce qu'il y a avant le pipe par la value en parametre
    //puis remettre le pipe et la value de l'autre input sinon insérer la value dans bloc.value + le pipe, verifier a la fin que la fromDate est plus petite que la ToDate

    // Si on veut enlever la valeur du block, on change la condition a vide
    if (this.utilities.isEmptyStr(value)) {
      bloc.Value = value;
      bloc.ValueDateDebut = '';
      bloc.ValueDateFin = '';
      bloc.Condition = '';
      return;
    }
    // Si il y avait déjà une valeur et qu'on veut la changer
    if (!this.utilities.isEmptyStr(bloc.Value) && bloc.Value.includes('|')) {
      var oldEndDate = bloc.Value.split('|')[1];
      bloc.Value = value + '|' + oldEndDate;
      // Sinon y avait pas de valeur et qu'on veut en mettre une
    } else if (!this.utilities.isEmptyStr(value)) {
      bloc.Value = value + '|';
    }
    // Remplacement de la condition si deux dates
    if (bloc.Value.includes('|')) {
      let dates = bloc.Value.split('|');
      if (!this.utilities.isEmptyStr(dates[0]) && !this.utilities.isEmptyStr(dates[1])) {
        this.setDateCondition(bloc, bloc.Value);
      }
    }
  }

  public OnToDateChange(bloc: BlocRecherche, value: string) {
    // Si on veut enlever la valeur du block, on change la condition a vide
    if (this.utilities.isEmptyStr(value)) {
      bloc.Value = value;
      bloc.ValueDateDebut = '';
      bloc.ValueDateFin = '';
      bloc.Condition = '';
      return;
    }
    // Si il y avait déjà une valeur et qu'on veut la changer
    if (!this.utilities.isEmptyStr(bloc.Value) && bloc.Value.includes('|')) {
      var oldStartDate = bloc.Value.split('|')[0];
      bloc.Value = oldStartDate + '|' + value;
      // Sinon y avait pas de valeur et qu'on veut en mettre une
    } else if (!this.utilities.isEmptyStr(value)) {
      bloc.Value = '|' + value;
    }
    // Remplacement de la condition si deux dates
    if (bloc.Value.includes('|')) {
      let dates = bloc.Value.split('|');
      if (!this.utilities.isEmptyStr(dates[0]) && !this.utilities.isEmptyStr(dates[1])) {
        this.setDateCondition(bloc, bloc.Value);
      }
    }
  }

  public getBorderColorOnBoolSelected(BlocSelected: BlocRecherche, value: string) {
    let borderCssValue: string;
    if (BlocSelected.Value == value) {
      borderCssValue = '2px solid var(--c-grey)';
    } else {
      borderCssValue = '2px solid #ffffff00';
    }
    return borderCssValue;
  }



  // #endregion

  // #region Fonctions private

  private setDateCondition(bloc: BlocRecherche, value: string) {
    var transformedFromDate = this.datepipe.transform(bloc.Value.split('|')[0], 'dd/MM/yyyy');
    var transformedtoDate = this.datepipe.transform(bloc.Value.split('|')[1], 'dd/MM/yyyy');
    if (transformedFromDate != null && transformedtoDate != null) {

      bloc.Condition = `${bloc.Column} >= Cast(''${transformedFromDate}'' as datetime) AND ${bloc.Column} <= Cast(''${transformedtoDate}'' as datetime)`;
    }
  }
  // #endregion

}




